module.exports = __webpack_public_path__ + "img/artFont.441af95e.svg";